import React from 'react'
import {GatsbyImage} from 'gatsby-plugin-image';
import styled from 'styled-components';
import FakeButton from './FakeButton';
import { Swiper, SwiperSlide } from 'swiper/react';
import Arrow from '.././../assets/slider-arrow.inline.svg'
import {Link}from 'gatsby';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import 'swiper/css/bundle';

SwiperCore.use([Autoplay, Navigation])

const CaseStudySliderSection = styled.section`
position:relative;
padding:4rem 0 0rem 2rem;

    @media only screen and (min-width: 1024px) {
    padding:8rem 0 0rem 2rem;
    }

    &:after{
    content:"";
    position: absolute;
    left:0;
    background-color:var(--${(props) => props.bgColor});
    width:100%;
    height:${(props) => props.bgSize};
    ${(props) => props.bgPosition}:0;
    z-index:-10;
    }


    .section-title{
    margin-bottom:2rem;
    margin-left:-1rem;
    }
    
    .arrows{
    position:absolute;
    right:2rem;
    top:0;

        .arrow{
        cursor: pointer;
        transition:0.5s all ease-in-out;

            &.inactive{
            cursor: default;
            pointer-events:none;
            opacity:0.3;
            }

        }

        .prev{
        transform:rotate(180deg);
        margin-right:2rem;
        }
    }

    .slider{
    width:100%;
    overflow:hidden;
    display:flex;
    list-style:none;

        .slide{
         width:calc(100% - 2rem);
        margin-right:1rem;
        font-family:var(--font-reg);
        display:flex;
        position: relative;
        flex-direction:column;
        justify-content:space-between;
        margin-bottom:2rem;
        padding-bottom:140%;
        overflow:hidden;
        cursor: pointer;

            @media only screen and (min-width: 450px) {
                padding-bottom:100%;
            }
            @media only screen and (min-width: 550px) {
                padding-bottom:70%;
            }
            
            @media only screen and (min-width: 768px) {
                padding-bottom:120%;
            }
            
            @media only screen and (min-width: 1024px) {
                width:100%;
                padding-bottom:0;
                height:28vw;
            }
            &:before{
            content:"";
            width:100%;
            height:100%;
            position: absolute;
            top:0;
            left:0;
            background: rgba(0,0,0,0.6);
            z-index:-1;
            mix-blend-mode:darken;
            transition:0.5s all ease-in-out;
            }

            a{
            text-decoration:none;
            color:var(--white);
            display:flex;
            position: absolute;
            flex-direction:column;
            /* justify-content:space-between; */ 
            height:100%;
            width:100%;
            padding:1.5rem;
            flex-wrap:wrap;
            }

            .fakeButton{
            position: absolute;
            bottom:34px;
            }

            .image-wrapper{
            width:100%;
            height:100%;
            position:absolute !important;
            top:0;
            left:0;
            z-index:-2;
            transition:0.5s all ease-in-out;
            }
            .logo-wrapper{
            width:100%;
            height:calc(100% - 110px);
            position:absolute !important;
            top:0;
            left:0;
            z-index:2;
            transition:0.5s all ease-in-out;

                img{
                width:80% !important;
                height:80% !important;
                left:10% !important;
                top:10% !important;
                object-fit:contain !important;
                }

            }

            &:hover{
                &:before{
                background: rgba(0,0,0,0.8);    
                }
                
                .fakeButton div{
                color:var(--black);
                
                    &:after{
                    transform:translateX(0%);
                    }
                    svg path{
                        fill:var(--black);
                    }
                }

                .image-wrapper{
                transform:scale(1.2)
                }
            }

        }

    }

`

export default function CaseStudySlider({
    sectionTitle, 
    data, 
    linkPrefix,
    bgPosition,
    bgSize,
    bgColor,
    }) {
    const nodes = data;

    return (
        <CaseStudySliderSection 
            bgPosition={bgPosition ? bgPosition : '0'}
            bgSize={bgSize ? bgSize : '0'}
            bgColor={bgColor ? bgColor : 'none'}
            className="caseStudySlider"
        >
            <div className={'slider-wrap--caseStudies'}>
                <div className="wrapper">
                    <h2 className="section-title heading--l">{sectionTitle}</h2>
                    <div className="arrows">
                        <Arrow
                            className="prev arrow"
                        />
                        <Arrow
                            className="next arrow"
                        />
                    </div>
                </div>
                
                <Swiper
                     spaceBetween={40}
                     breakpoints={{
                        // when window width is >= 640px
                        640: {
                          slidesPerView: 1,
                          spaceBetween: 0,
                        },
                        // when window width is >= 768px
                        768: {
                          slidesPerView: 2,
                          spaceBetween: 0,
                        },
                        1024:{
                            slidesPerView: 2.5,
                            spaceBetween: 40,
                        },
                        1600:{
                            slidesPerView: 3.5,
                            spaceBetween: 40,
                        }
                      }}
                     // slidesPerView={3.5}
                     autoplay={true, {
                         delay: 4500,
                      }}
                    navigation={ {
                        nextEl: '.slider-wrap--caseStudies .arrow.next',
                        prevEl: '.slider-wrap--caseStudies .arrow.prev',
                    }}
                    loop={true}
                    className="slider"
                    >
                    {
                        nodes.map((item, index) => {      
                            return(
                                <SwiperSlide key={item.title + '_' + index}>
                                    <article className="slide">
                                        <Link to={'/case-studies/'+item.chooseACaseStudy.slug}>
                                            <GatsbyImage className="logo-wrapper" image={item?.chooseACaseStudy?.acf_caseStudyFields?.logo?.localFile?.childImageSharp?.gatsbyImageData} />
                                            <FakeButton 
                                                color="white" 
                                                text="Read now" 
                                                withHover={false}
                                            />
                                            <GatsbyImage className="image-wrapper" image={item?.chooseACaseStudy?.acf_caseStudyFields?.backgroundImage?.localFile?.childImageSharp?.gatsbyImageData} />
                                        </Link>
                                    </article>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
            </div>
        </CaseStudySliderSection>             
    )
}
